import { z } from "zod"

const phoneRegex = /^\+\d{8,15}$/

export const selfRegisterDeviceSchema = z.object({
  phoneNumber: z.string().regex(phoneRegex, "Use international format e.g. +13105551234"),
  deviceCode: z.string().min(1),
})

export type SelfRegisterDeviceFormData = z.infer<typeof selfRegisterDeviceSchema>
